import { Component, Inject, OnInit, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'm-url-dialog',
    templateUrl: './url-dialog.component.html'
})
export class UrlDialogComponent implements OnInit {
    viewLoading: boolean = false;
    submitted: boolean = false;
    constructor(
        public dialogRef: MatDialogRef<UrlDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        let iframe = document.getElementById('myIframe') as HTMLIFrameElement;
        iframe.src = this.data.url;
       
    }

}
